import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";

// Accepts any collection-like shape with a title + image — both the full `Collection` and the
// lighter `TierCollectionCard` (the budget-tier browse card) satisfy it.
export interface CollectionCardProps {
  collection: { title: string; imageUrl: string };
  onClick: () => void;
}

export default function CollectionCard({ collection, onClick }: CollectionCardProps) {
  return (
    <Card
      sx={{
        borderRadius: "10px",
        boxShadow: "none",
        border: "0.524px solid rgba(0,0,0,0.1)",
        backgroundColor: "#ffffff",
        overflow: "hidden",
        transition: "box-shadow 0.2s, transform 0.2s",
        "&:hover": {
          boxShadow: "0 4px 20px rgba(0,0,0,0.10)",
          transform: "translateY(-2px)",
        },
      }}
    >
      <CardActionArea
        onClick={onClick}
        aria-label={`View ${collection.title}`}
        sx={{ display: "flex", flexDirection: "column", alignItems: "stretch", height: "100%" }}
      >
        <Box
          sx={{
            width: "100%",
            aspectRatio: "1 / 1",
            backgroundColor: "#f5f5f5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          {collection.imageUrl ? (
            <Box
              component="img"
              src={collection.imageUrl}
              alt={collection.title}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          ) : (
            <Box
              sx={{
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                backgroundColor: "#e0e0e0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography sx={{ fontSize: "20px", color: "#bdbdbd" }}>🎁</Typography>
            </Box>
          )}
        </Box>

        {/* Info area */}
        <Box
          sx={{
            px: "12px",
            py: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "6px",
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: 1,
              color: "text-primary",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {collection.title}
          </Typography>

          {/* <Chip
            label={`${collection.itemCount} Items`}
            size="small"
            sx={{
              alignSelf: "flex-start",
              height: "20px",
              backgroundColor: "#c1c8bc",
              color: "#ffffff",
              fontSize: "12px",
              fontWeight: 700,
              "& .MuiChip-label": { px: "10px" },
            }}
          /> */}
        </Box>
      </CardActionArea>
    </Card>
  );
}
